import type { PropType } from 'virtual-vue';
import type { ButtonSize, ButtonTheme, ButtonType } from './button';


export const DEFAULT_BUTTON_TYPE = 'primary';

export const DEFAULT_BUTTON_SIZE = 'middle';

export const DEFAULT_BUTTON_THEME = 'default';

/**
 * 组件的props
 */
export const props = {
  /**
   * 按钮类型
   * @default 'primary'
   */
  type: {
    type: String as PropType<ButtonType>,
    default: DEFAULT_BUTTON_TYPE,
  },
  /**
   * 按钮大小
   * @default 'middle'
   */
  size: {
    type: String as PropType<ButtonSize>,
    default: DEFAULT_BUTTON_SIZE,
  },
  /**
   * 是否禁用按钮
   * @default false
   */
  disabled: Boolean,
  /**
   * 展示禁用样式
   * @default false
   */
  disabledStyle: Boolean,
  /**
   * 按钮主题
   * @default 'default'
   */
  theme: {
    type: String as PropType<ButtonTheme>,
    default: DEFAULT_BUTTON_THEME,
  },
};
